import { cn } from "@/lib/utils";
import React from "react";

// Semantic light status chip (see DESIGN.md "状态徽章"). Colors are theme
// tokens defined in globals.css (`--chip-*`, light + dark) — screens must not
// hand-write `bg-*-100 text-*-800` spans.
const TONES = {
  neutral: "bg-muted text-muted-foreground",
  // Subtle brand tint for "alive/active" semantics (e.g. an in-flight
  // version relation), sitting between neutral and the alert colors.
  primary: "bg-primary/10 text-primary",
  // Alert tint for "needs attention" semantics (e.g. an unmerged PR).
  destructive: "bg-destructive/10 text-destructive",
  green: "bg-chip-green text-chip-green-foreground",
  emerald: "bg-chip-emerald text-chip-emerald-foreground",
  red: "bg-chip-red text-chip-red-foreground",
  yellow: "bg-chip-yellow text-chip-yellow-foreground",
  orange: "bg-chip-orange text-chip-orange-foreground",
  blue: "bg-chip-blue text-chip-blue-foreground",
  purple: "bg-chip-purple text-chip-purple-foreground",
  lime: "bg-chip-lime text-chip-lime-foreground",
  cyan: "bg-chip-cyan text-chip-cyan-foreground",
  teal: "bg-chip-teal text-chip-teal-foreground",
  rose: "bg-chip-rose text-chip-rose-foreground",
} as const;

export type ChipTone = keyof typeof TONES;

// For interactive elements (Button/DropdownMenuTrigger) that need chip looks.
export const chipClass = (tone: ChipTone, className?: string) =>
  cn(
    "shrink-0 rounded px-1.5 py-0.5 text-xs font-medium",
    TONES[tone],
    className
  );

export const Chip = ({
  tone = "neutral",
  className,
  ...props
}: React.ComponentProps<"span"> & { tone?: ChipTone }) => (
  <span className={chipClass(tone, className)} {...props} />
);

export default Chip;
